import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './components/Home.js';
import Trading from './components/Tranding.js';
import Platform from './components/Platform.js';
import AboutPage from './components/AboutPage.js';
import Partner from './components/Partner.js';
import Contact from './components/Contact.js';
import Privacy from './components/PrivacyPolicy.js';
import Terms from './components/Terms.js';
import RefundPolicy from './components/RefundPolicy.js';
import Education from './components/Education.js';

import '@fontsource/poppins'; // Defaults to 400 weight
import '@fontsource/poppins/100.css'; // Specific weight



function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/About' element={<AboutPage />} />
        <Route path='/trading' element={<Trading />} />
        <Route path='/platform' element={<Platform />} />
        <Route path='/partner' element={<Partner />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/refund' element={<RefundPolicy />} />
        <Route path='/education' element={<Education />} />

      </Routes>
    </Router>
  );
}

export default App;
